import {
  Box,
  CircularProgress,
  List,
  Typography,
} from "@mui/material";

import {
  SearchablePopoverListProps,
} from "./searchable-popover.types";

import { SearchablePopoverItem } from "./SearchablePopoverItem";

export const SearchablePopoverList = <T,>({
  items,
  selectedValue,
  getKey,
  renderItem,
  onSelect,
  emptyMessage = "No results found",
  loading = false,
}: SearchablePopoverListProps<T>) => {
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: 150,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (!items.length) {
    return (
      <Box
        sx={{
          px: 2,
          py: 4,
          textAlign: "center",
        }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
        >
          {emptyMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <List disablePadding>
      {items.map((item) => {
        const key = getKey(item);

        const selected =
          selectedValue !== null &&
          selectedValue !== undefined &&
          getKey(selectedValue) === key;

        return (
          <SearchablePopoverItem
            key={key}
            item={item}
            selected={selected}
            renderItem={renderItem}
            onClick={onSelect}
          />
        );
      })}
    </List>
  );
};